/**
 * 活体协议签署弹窗事件名称枚举
 */
export enum LivenessSignAgreementsPopEvents {
  /** 弹窗显示状态更新 */
  UPDATE_SHOW = 'update:show',
  /** 协议签署完成 */
  AGREEMENT_CONFIRMED = 'agreement-confirmed',
  /** 活体认证成功 */
  LIVENESS_SUCCESS = 'liveness-success',
  /** 活体认证失败 */
  LIVENESS_FAIL = 'liveness-fail',
  /** 用户关闭弹窗 */
  CLOSE = 'close',
  /** 用户取消操作 */
  CANCEL = 'cancel',
}
